// ANX-076 — вспомогательные чистые функции composer'а оператора:
// вставка emoji в позицию каретки и извлечение файла из drag&drop / paste.
// Вынесены из ConversationView ради юнит-тестируемости.

/**
 * insertAtCursor — вставляет `ins` в строку `value`, заменяя выделение
 * [start, end). Возвращает новое значение и позицию каретки после вставки.
 * Индексы за пределами строки безопасно клампятся (вставка в конец).
 */
export function insertAtCursor(
  value: string,
  start: number,
  end: number,
  ins: string,
): { value: string; caret: number } {
  const s = Math.max(0, Math.min(start, value.length));
  const e = Math.max(s, Math.min(end, value.length));
  return {
    value: value.slice(0, s) + ins + value.slice(e),
    caret: s + ins.length,
  };
}

/**
 * firstDroppedFile — первый файл из DataTransfer события drop.
 * При перетаскивании текста/ссылок `files` пуст → null.
 */
export function firstDroppedFile(dt: DataTransfer | null): File | null {
  if (!dt || !dt.files || dt.files.length === 0) return null;
  return dt.files[0] ?? null;
}

/**
 * firstPastedFile — файл из буфера обмена (Ctrl+V).
 * Сначала пробуем `files` (Chrome/Firefox), затем сканируем `items`
 * на kind==='file' (Safari, вставка скриншота). Обычный текст → null.
 */
export function firstPastedFile(cd: DataTransfer | null): File | null {
  if (!cd) return null;
  if (cd.files && cd.files.length > 0) return cd.files[0] ?? null;
  const items = cd.items;
  if (items) {
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      if (it.kind === 'file') {
        const f = it.getAsFile();
        if (f) return f;
      }
    }
  }
  return null;
}
